import * as React from 'react';
import { useSpinnerStyles } from './Spinner.styles';
import { CircularProgress } from '@material-ui/core';

export enum SpinnerAlignment {
    CENTERED = 'centered',
}

export interface ISpinnerProps {
    alignment?: SpinnerAlignment;
}

export const Spinner = ({ alignment }: ISpinnerProps) => {
    const classes = useSpinnerStyles();

    return !alignment ? (
        <CircularProgress
            data-signa="circular-spinner"
            variant={'indeterminate'}
            color="primary"
        />
    ) : (
        <div className={classes[alignment]} data-signa="spinner-container">
            <CircularProgress
                variant={'indeterminate'}
                color="primary"
            />
        </div>
    );
};
